import { createGlobalStyle } from 'styled-components'
import { COLLAPSE_CLASSNAME, COLLAPSE_DURATION } from './constants'

const CollapseStyle = createGlobalStyle`
    .${COLLAPSE_CLASSNAME} {
        transition: height ${COLLAPSE_DURATION}ms;
    }
`

export default CollapseStyle
